<template>
  <div class="orderList">
    <div class="nav_bar">
      <div class="nav_title">订单列表</div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部订单" name="first">
        <div class="card_block">
          <div
            class="card_item"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div class="form">
              <span class="label">订单编号：</span>{{ item.order_no }}
            </div>
            <div class="form">
              <span class="label">设备编号：</span>{{ item.equipment_no }}
            </div>
            <div class="form">
              <span class="label">下单时间：</span>{{ item.succ_pay_time }}
            </div>
            <div class="form last">
              <span class="des1">实付</span>
              <span class="money">￥{{ item.money }}</span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="使用中" name="second">
        <template v-if="deviceGroups.length > 0">
        <div class="device_group" v-for="group in deviceGroups" :key="group.equ_id">
          <div class="device_no">设备编号：{{ group.equ_id }}</div>
          <div class="rings">
            <div class="ring_item" v-for="r in group.rings" :key="r.type">
              <div class="ring_icon"><img :src="r.imgIcon" alt="" /></div>

              <div class="ring_info">
                <div class="ring_label">{{ r.name }}</div>
                <div class="ring_label_detail">{{ r.name_detail }}</div>
                <div class="ring_label_times">剩余时间</div>
                <div class="ring_time">{{ secondsToHMS(r.level) }}</div>
                <div class="ring_label_times">时/分/秒</div>
              </div>
              <div class="ring_wrap">
                <el-progress
                  :show-text="false"
                  :stroke-width="8"
                  :width="90"
                  type="circle"
                  :percentage="r.percent"
                  color="#3ca1e2"
                  define-back-color="#a1cfed"
                />
                <div class="ring_center">{{ r.percent }}%</div>
              </div>
            </div>
          </div>
          <div class="card_block">
            <div
              class="card_item"
              v-for="(item, index) in group.orders"
              :key="index"
            >
              <div class="form">
                <span class="label">订单编号：</span>{{ item.order_no }}
              </div>
              <div class="form">
                <span class="label">设备编号：</span>{{ item.equipment_no }}
              </div>
              <div class="form">
                <span class="label">下单时间：</span>{{ item.succ_pay_time }}
              </div>
              <div class="form">
                <span class="label">实付金额：</span>￥{{ item.money }}
              </div>
              <!-- <div class="form last">
                <span class="des1">实付</span>
                <span class="money">￥{{ item.money }}</span>
              </div> -->
              <div class="form">
                <span class="label">当前订单服务</span>
                <div>
                  <span v-if="item.charge_time > 1">充电{{ item.charge_time / 60 / 60 }}小时/</span>
                  <span v-if="item.chair_time > 1">按摩{{ item.chair_time / 60 / 60 }}小时/</span>
                  <span v-if="item.pad_time > 1">平板{{ item.pad_time / 60 / 60 }}小时</span>
                  <!-- 充电{{ item.charge_time }}分钟/按摩{{ item.chair_time }}分钟/平板{{ item.pad_time }}分钟 -->
                </div>
              </div>
            </div>
          </div>
        </div>
        </template>
        <div v-else>
          <div  class="no_data">暂无运行中的订单</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="申请退款" name="third">
        <div class="card_block" v-if="refund_order_list.length > 0">
          <div
            class="card_item card_item_pro"
            v-for="(item, index) in refund_order_list"
            :key="index"
          >
            <!-- <div class="progress">
              <el-progress
                :show-text="false"
                :stroke-width="10"
                :width="160"
                type="circle"
                :percentage="item.percent || 0"
                color="#3ca1e2"
                define-back-color="#a1cfed"
              >
              </el-progress>
              <div class="time_cnt">
                <div class="des1">剩余</div>
                <div class="time">{{ item.time || "00:00:00" }}</div>
                <div class="des2">时/分/秒</div>
              </div>
            </div> -->

            <div class="form_cnt">
              <div class="form">
                <span class="label">订单编号：</span>{{ item.order_no }}
              </div>
              <div class="form">
                <span class="label">设备编号：</span>{{ item.equipment_no }}
              </div>
              <div class="form line">
                <span class="label">订单金额：</span>
                <div>
                  <span class="des1">实付</span>
                  <span class="money">￥{{ item.money }}</span>
                </div>
              </div>
              <div class="form last1" @click="handleDialog1(item)">
                <div class="refude_btn">申请退款</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="no_data">暂无运行中的订单</div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 提示的弹窗1 -->
    <div class="dialog1" v-show="isShowDialog1">
      <div class="diaMain">
        <img
          class="dialog1_bg"
          src="@/assets/adule_img/btnList/dialog1_bg.png"
          alt=""
        />
        <img
          class="money_icon"
          src="@/assets/adule_img/btnList/money_icon.png"
          alt=""
        />
        <div class="title">—申请退款—</div>
        <div class="cnt">非设备故障问题不可申请退款</div>
        <!-- 打开退款弹窗 -->
        <div class="btn btn1" @click="isShowDialog1 = false">取消</div>
        <div class="btn" @click="handleApplyRefund">确定</div>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      custom-class="dialogMessage"
      :show-close="false"
    >
      <el-form ref="form" :model="form" inline :rules="rules">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="form.name" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="contact">
          <el-input
            v-model="form.contact"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请内容" prop="re_mark">
          <el-input
            v-model="form.re_mark"
            placeholder="请输入申请内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 底部 TabBar -->
    <AdultNewTabBar />
  </div>
</template>

<script>
import axios from "axios";
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'
export default {
  name: "WorkspaceJsonOrderList",
  components: { AdultNewTabBar },

  data() {
    return {
      activeName: "first",
      // 订单列表
      orderList: [
        // {
        //   equipment_no: "861538074454478",
        //   id: 3907410,
        //   money: 0.01,
        //   order_no: "20258178448658199800",
        //   order_state: 2,
        //   order_type: 1,
        //   project_no: "A250701000",
        //   succ_pay_time: "2025-08-01 14:55:12",
        //   remain_seconds: 120, // 剩余时间，单位秒
        //   all_time: 3600, // 总时长，单位秒
        // },
      ],
      time: "", // 时间戳
      timer: null, // 定时器
      remainingSeconds: "",
      isShowDialog1: false, //打开弹窗1
      dialogVisible2: false, //打开弹窗2
      itemObj: {},
      form: {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      },
      rules: {
        name: [{ required: true, trigger: "blur", message: "请输入联系人" }],
        contact: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        re_mark: [
          { required: true, trigger: "blur", message: "请输入申请内容" },
        ],
      },
      timers: {}, // 存储每个订单的定时器
      percent: 0, // 进度条百分比
      remainingTimes: {}, // 存储每个订单的剩余时间(秒)
      allTimes: {}, // 存储每个订单的总时长(秒)
      deviceGroups: [], // 使用中：按设备编号分组，每组含三个圆环 + 订单列表
      ringTimer: null, // 圆环剩余时间倒计时定时器
      open_id:  "ovA4QwV_eRGr6CkA1VEjathmNwx8", // 用户open_id
      refund_order_list: [],
      // 运行中的订单列表
    };
  },

  mounted() {
    const tab = this.$route.query.tab;
    if (tab === "second" || tab === "third") {
      this.activeName = tab;
      this.getList2();
    } else {
      this.getList();
    }
  },

  beforeDestroy() {
    // 清除所有定时器
    Object.keys(this.timers).forEach((id) => {
      clearInterval(this.timers[id]);
      this.$delete(this.timers, id);
    });
    this.clearRingCountdown();
  },
  methods: {
    handleClick() {
      if (this.activeName == "first") {
        this.getList();
      } else if (this.activeName == "second") {
        this.getList2();
      } else if (this.activeName == "third") {
        this.getList2();
      }
    },
    // 全部订单  http://192.168.110.100:80001/
    // || "ovA4QwV_eRGr6CkA1VEjathmNwx8"
    getList() {
      axios({
        method: "get",
        url: "https://htapi.zxznzy.com/project/adult_h5_order_list",
        params: {
          open_id:
            localStorage.getItem("open_id") || this.open_id, // 用户open_id
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            this.orderList = res.data.data.order_list; // 更新订单列表
          } else {
            this.$message.error("获取订单列表失败");
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    // 运行中的订单
    getList2() {
      axios({
        method: "get",
        url: "https://htapi.zxznzy.com/project/adult_h5_order_running_detail_new",
        params: {
          open_id:
            localStorage.getItem("open_id") || this.open_id, // 用户open_id
        },
      })
        .then((res) => {
          if (res.data.code == 1) {
            if (this.activeName == "second") {
              const data = res.data.data || {};
              this.deviceGroups = Object.keys(data).map((equ_id) => {
                const arr = data[equ_id] || [];
                const ring = arr.find((o) => !o.order_no) || {};
                return {
                  equ_id,
                  rings: this.buildRings(ring),
                  orders: arr.filter((o) => o.order_no),
                };
              });
              console.log(this.deviceGroups,'.....');
              this.startRingCountdown();
            }
            if (this.activeName == "third") {
              const orderList_org = res.data.data; // 更新订单列表
              const orderList = Object.values(orderList_org).flatMap(arr => arr.slice(1))
              // console.log(orderList_org,'.....org');
              // Object.values(orderList_org).forEach(arr => {
              //   // slice(1) 跳过第0个统计对象，剩下都是订单
              //   this.orderList.push(...arr.slice(1))
              // })
              console.log(orderList,'.....')
              this.refund_order_list = orderList
            }
          } else {
            this.$message.error("获取订单列表失败：" + res.data.message);
          }
        })
        .catch(() => {
          this.$message.error("获取订单列表失败");
        });
    },
    // 启动倒计时
    startCountdown(orderId, seconds, allTime) {
      // 清除已有定时器
      if (this.timers[orderId]) {
        clearInterval(this.timers[orderId]);
        this.$delete(this.timers, orderId);
      }

      // 初始化时间数据
      this.$set(this.remainingTimes, orderId, seconds);
      this.$set(this.allTimes, orderId, allTime);

      // 立即更新首次进度
      this.updateProgress(orderId);

      // 启动新定时器
      this.timers[orderId] = setInterval(() => {
        if (this.remainingTimes[orderId] <= 0) {
          clearInterval(this.timers[orderId]);
          this.$delete(this.remainingTimes, orderId);
          this.updateProgress(orderId); // 最终更新为0
          this.$message.success(`订单${orderId}体验时间已结束`);
        } else {
          this.remainingTimes[orderId]--;
          this.updateProgress(orderId);
        }
      }, 1000);
    },
    // 更新进度条百分比和时间显示
    updateProgress(orderId) {
      const index = this.orderList.findIndex((item) => item.id === orderId);
      if (index > -1) {
        const remaining = this.remainingTimes[orderId] || 0;
        const total = this.allTimes[orderId] || 3600;
        const percent = Math.round((remaining / total) * 100);

        // 使用Vue.set确保响应式更新
        this.$set(this.orderList, index, {
          ...this.orderList[index],
          percent: Math.max(0, Math.min(100, percent)),
          time: this.secondsToHMS(remaining),
        });
      }
    },

    // 启动圆环倒计时：每秒递减各功能的剩余时间
    startRingCountdown() {
      this.clearRingCountdown();
      this.ringTimer = setInterval(() => {
        this.deviceGroups.forEach((group) => {
          group.rings.forEach((r) => {
            if (r.level > 0) {
              r.level -= 1;
              r.percent =
                r.all > 0
                  ? Math.min(100, Math.max(0, Math.round((r.level / r.all) * 100)))
                  : 0;
            }
          });
        });
      }, 1000);
    },
    // 清除圆环倒计时
    clearRingCountdown() {
      if (this.ringTimer) {
        clearInterval(this.ringTimer);
        this.ringTimer = null;
      }
    },

    // 构建三个圆环：影视娱乐 / 座椅按摩 / 手机充电
    buildRings(ring) {
      const r = ring || {};
      const defs = [
        { type: "pad", name: "平板娱乐", name_detail: '影视娱乐·精彩随行', imgIcon: require('@/assets/new_adult_img/娱乐.png') },
        { type: "chair", name: "平躺+按摩", name_detail: '舒服躺卧·轻松按摩', imgIcon: require('@/assets/new_adult_img/按摩.png') },
        { type: "charge", name: "充电服务", name_detail: '快速充电·电量无忧', imgIcon: require('@/assets/new_adult_img/充电.png') },
      ];
      return defs.map((d) => {
        const all = Number(r[d.type + "_time_all"]) || 0;
        const level = Number(r[d.type + "_time_level"]) || 0;
        return {
          ...d,
          all,
          level,
          percent:
            all > 0
              ? Math.min(100, Math.max(0, Math.round((level / all) * 100)))
              : 0,
        };
      });
    },

    // 秒数转HH:MM:SS
    secondsToHMS(seconds) {
      const pad = (num) => num.toString().padStart(2, "0");
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    },
    updateTime() {
      if (this.remainingSeconds <= 0) {
        clearInterval(this.timer);
        this.time = "00:00:00";
        // this.$message.success("体验时间已结束");
        return;
      }
      this.time = this.secondsToHMS(this.remainingSeconds--);
    },
    // 打开弹窗的提示1
    handleDialog1(item) {
      this.itemObj = item; // 保存当前订单信息
      this.isShowDialog1 = true;
    },

    //点击申请退款，打开弹窗
    handleApplyRefund() {
      this.form = {
        name: "", //联系人
        contact: "", // 手机号
        re_mark: "", // 申请内容
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.isShowDialog1 = false;
      this.dialogVisible2 = true;
    },
    // 申请退款的确定
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          axios({
            method: "post",
            url: "https://htapi.zxznzy.com/project/wx_refund_back",
            data: {
              order_no: this.itemObj.order_no,
              open_id:
                localStorage.getItem("open_id") ||
                this.open_id, // 用户open_id
              ...this.form,
            },
          })
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.message || "申请退款成功");
                this.dialogVisible2 = false;
              } else {
                this.$message.error(res.data.message || "申请退款失败");
              }
            })
            .catch((err) => {
              this.$message.error(
                (err.response && err.response.data.message) || "申请退款失败"
              );
            });
        }
      });
    },
    // 跳转到详情
    handleDetail(item) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          order_id: item.id,
          order_no: item.order_no,
          equipment_no: item.equipment_no,
          money: item.money,
        },
      });
    },
  },
};
</script>
  <!-- background: linear-gradient(to bottom, #c1f7f5, #fff); -->

<style lang="scss" scoped>
.no_data {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #999797;
  margin-top: 20px;
}
.orderList {
background-color: #f7f7f7;
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px 70px; /* 底部 70px 给 TabBar 让位 */
  overflow-x: hidden;
  max-width: 100vw;

  .card_block {
    width: 100%;
    max-height: 90vh;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
  }
  .card_item {
    border-radius: 10px;
    width: 100%;
    padding-left: 15px;
    margin-top: 10px;
    box-sizing: border-box;
    background: #fff;

    .form {
      margin: 10px 0;
      border-bottom: 1px solid #e8e8e8;
      padding-bottom: 10px;
      box-sizing: border-box;
      .des1 {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 12px;
        color: #010101;
        margin-right: 2px;
      }
      .money {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 17px;
        color: #3ca1e2;
      }
      .label {
        background: #3ca1e2;
        color: #fff;
        text-align: center;
        font-size: 14px;
        border-radius: 4px;
        padding: 0 0px 0 8px;
        margin-right: 10px;
      }
    }
    .form.last {
      border-bottom: none;
      text-align: right;
      padding-right: 15px;
    }
    .form.line {
      display: flex;
      justify-content: space-between;
      padding-right: 15px;
    }
    .form.last1 {
      display: flex;
      align-items: center;
      justify-content: right;
      border-bottom: none;
      text-align: right;
      padding-right: 10px;
    }
    .refude_btn {
      color: #fff;
      background: #3ca1e2;
      border-radius: 10px;
      padding: 4px 10px;
      font-size: 14px;
    }
  }
  .card_item:last-child {
    margin-bottom: 10px;
  }
  .device_group {
    width: 100%;
    margin-top: 10px;
    .device_no {
      font-size: 14px;
      font-weight: 600;
      color: #1a3c5e;
      margin-bottom: 6px;
    }
    .rings {
      display: flex;
      flex-direction: column;
      // background: #fff;
      border-radius: 10px;
    padding: 13px 12px;
    margin-bottom: 10px;
    background: rgb(255, 255, 255);
    }
    .ring_item {
      display: flex;
      align-items: center;
      gap: 15px;
      padding: 10px 9px;
      border-bottom: 1px solid #f0f0f0;
      margin-bottom: 10px;
      background-color: aliceblue;
      border-radius: 10px;
      justify-content: space-between;
    }
    .ring_item:last-child {
      border-bottom: none;
    }
    .ring_wrap {
      position: relative;
      width: 90px;
      height: 90px;
      flex-shrink: 0;
    }
    .ring_icon {
      width: 40px;
      height: 40px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
    }
    .ring_center {
      position: absolute;
      top: 0;
      left: 0;
      width: 90px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      color: #3ca1e2;
      pointer-events: none;
    }
    .ring_info {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
    .ring_time {
      font-size: 16px;
      font-weight: bold;
      color: #3ca1e2;
    }
    .ring_percent {
      font-size: 13px;
      color: #999;
    }
    .ring_label {
      font-size: 18px;
      font-weight: bolder;
      color: #333;
    }
  }
  .card_item_pro {
    background: none;
    padding-left: 0;
    .progress {
      text-align: center;
      position: relative;
      .time_cnt {
        position: absolute;
        top: 32px;
        left: 33vw;
        .des1 {
          color: #3ca1e2;
          font-size: 24px;
          font-weight: bold;
        }
        .time {
          color: #3ca1e2;
          font-size: 24px;
          margin: 10px 0;
        }
        .des2 {
          color: #bad8d8;
        }
      }
    }
    .form_cnt {
      padding-left: 15px;
      background: #fff;
      .form {
        padding-top: 10px;
      }
    }
  }
  .dialog1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(128, 128, 128, 0.5);
    .diaMain {
      width: 90vw;
      position: absolute;
      top: 40vh;
      left: 8vw;
      z-index: 2;
      border-radius: 20rpx;

      .dialog1_bg {
        width: 90vw;
        height: 34vh;
      }
      .money_icon {
        width: 22vw;
        position: absolute;
        z-index: 2;
        right: 1vw;
      }
      .title {
        position: absolute;
        z-index: 2;
        right: 30vw;
        top: 3vh;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 23px;
        color: #353636;
      }
      .cnt {
        position: absolute;
        z-index: 2;
        right: 13vw;
        top: 14vh;
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        font-size: 18px;
        color: #353636;
        font-weight: bold;
      }
      .btn.btn1 {
        position: absolute;
        z-index: 2;
        top: 22vh;
        left: 12vw;
        background: #a5bcbb;
      }
      .btn {
        font-family: FZLanTingHeiS-DB-GB;
        font-weight: 400;
        color: #ffffff;
        background: #27a8a6;
        position: absolute;
        z-index: 2;
        top: 22vh;
        left: 50vw;
        width: 107px;
        height: 4.5vh;
        text-align: center;
        line-height: 4.5vh;
        border-radius: 6px;
      }
    }
  }
}
::v-deep {
  .el-tabs__header.is-top {
    width: 90vw;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .el-tabs__item.is-active {
    color: #2b96db;
  }
}
::v-deep {
  .el-dialog__body {
    padding: 30px 0 !important;
  }
  .dialogMessage {
    margin-top: 20vh !important;
    width: 90% !important;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      box-sizing: border-box;
      letter-spacing: 2px;
    }
  }
}

/* 顶部导航 */
.nav_bar {
  position: relative;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.nav_title {
  font-size: 16px;
  font-weight: 600;
  color: #1a3c5e;
}
.ring_label_detail {
  font-size: 14px;
  color: #748597;
}
.ring_label_times {
  font-size: 14px;
  color: #748597;
}
</style>